var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loadding)?_c('router-view'):_c('loading')
}
var staticRenderFns = []

export { render, staticRenderFns }